import React from 'react'
import './Aloqa.css'
import Phone from '../../assets/Aloqa/phone.svg'
import Email from '../../assets/Aloqa/mail.svg'
import Locat from '../../assets/Aloqa/location-marker.svg'

 const Aloqa=()=> {
  return (
    <div className='Aloqa'>
      <div className='Contact'>
        <div className='Contact__info'>
          
          <div className='Contact__info-phone'>
            <img src={Phone} alt="" />
            <div>
            <p >+998 95 169-8555 </p>
            <p>+998 99 791-8556 </p></div>
          </div>
          <div className='Contact__info-location'>
            <img src={Locat} alt="" />
            <p >Toshkent sh, Olmazor tumani,4-A uy </p>
            
          </div>
          <div className='Contact__info-email'>
            <img src={Email} alt="" />
            <p >info@amit.uz </p>
            
          </div>

        </div>

        <h4 className='Contact__heading'>Tezkor aloqa</h4>
        <p className='Contact__p'>Bizga xabaringizni koldiring. Sizning xabaringizni albatta inobatga olamiza!</p>
        <div className='Contact__form'>
          <input type="text" placeholder='Ismingiz' />
          <input type="email" placeholder='E-mail'/>
          <input type="text" placeholder='Sarlavha'/>
          <input type="text" className='arealabel' placeholder="To'liq matn" />
        </div>
        <button className='Contact__submit'>Yuborish</button>
      </div>
      <div className='Location'><div style={{position:'relative',overflow:'hidden'}}><a href="https://yandex.com/maps/10335/tashkent/?utm_medium=mapframe&utm_source=maps" style={{color:'#eee',fontSize:'12px',position:'absolute',top:'0px'}}>Tashkent</a><a href="https://yandex.com/maps/10335/tashkent/?ll=69.211369%2C41.352668&utm_medium=mapframe&utm_source=maps&z=15" style={{color:'#eee',fontSize:'12px',position:'absolute',top:'14px'}}>Yandex.Maps: search for places, addresses, and public transport</a><iframe src="https://yandex.com/map-widget/v1/-/CCUMb0RecC" 
       style={{position:'relative'}}></iframe></div></div>
    </div>
  )
}
export default Aloqa


